import React from 'react';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import PageNudge from './PageNudge';
import useColumnState from './useColumnState';
import { PROJECT_NAV_FLAT, buildRoute } from '../../utils/projectNavManifest';
import '@/styles/project-desk-mockup.css';

/**
 * DP278-C6c-2 — the same line on the standalone project pages, mounted once at
 * the route level above the page's own header. A path the manifest does not
 * know draws nothing.
 */
export const ProjectRouteNudge = () => {
  const { projectId } = useParams();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const columnState = useColumnState(projectId);

  const item = PROJECT_NAV_FLAT.find(
    (i) => i.route && buildRoute(projectId, i.route) === pathname,
  );
  if (!item || item.framed) return <Outlet />;

  return (
    <>
      <div className="kpd-nudge-route">
        <PageNudge
          testId={item.testId}
          projectId={projectId}
          columnState={columnState}
          onTab={(v) => navigate(`/projects/${projectId}/desk?tab=${v}`)}
          onRoute={navigate}
        />
      </div>
      <Outlet />
    </>
  );
};

export default ProjectRouteNudge;
